import _ from 'lodash';

const getBaseUrl = () => {
    return '/';
};

const getEnvs = () => {
    const hostName = window?.location?.hostname;
    if (hostName?.toLowerCase().includes('devplayground.rightresponse.ai')) {
        return ['dev'];
    } else if (hostName?.toLowerCase().includes('playground.rightresponse.ai')) {
        return ['test', 'demo', 'prod'];
    } else if (hostName?.toLowerCase().includes('playground.reviewmgmtportal.com')) {
        return ['testrmp', 'prodrmp'];
    }
    return ['dev']
}
// Every environment, in display order. The env selector shows only the ones this host serves,
// while the prompt list badges span all of them.
const allEnvList = [
    { label: 'RR Dev', value: 'dev' },
    { label: 'RR Test', value: 'test' },
    { label: 'RR Demo', value: 'demo' },
    { label: 'RR Prod', value: 'prod' },
    { label: 'RMP Test', value: 'testrmp' },
    { label: 'RMP Prod', value: 'prodrmp' }
]
const getEnvsList = () => {
    const envs = getEnvs();

    return _.filter(allEnvList, env => _.includes(envs, env.value));
}
const getAppMode = () => {
    const envList = getEnvs();
    const env = sessionStorage.getItem('env') && _.includes(envList, sessionStorage.getItem('env')) ? sessionStorage.getItem('env') : envList[0];
    return env;
};
const getLiveSessionId = () => {
    const appMode = getAppMode();
    if (_.includes(['dev'], appMode )) return "9318bc49.688471be";
    if (_.includes(['test', 'demo', 'prod'], appMode )) return "9318bc49.2735021e";
    if (_.includes(['testrmp', 'prodrmp'], appMode )) return "9318bc49.2a8ecdaa";

    return "";
};
const getSignalRAutoRefreshUrl = () => {
    if (window.location.hostname === 'localhost') return "https://localhost:7224/SignalRHub/";
    const appMode = getAppMode();
    if (appMode === 'dev') return "https://devplayground.rightresponse.ai/SignalRHub/";
    if (appMode === 'testrmp') return "https://playground.reviewmgmtportal.com/SignalRHub/";
    if (appMode === 'prodrmp') return "https://playground.reviewmgmtportal.com/SignalRHub/";
    if (appMode === 'test') return "https://playground.rightresponse.ai/SignalRHub/";
    if (appMode === 'demo') return "https://playground.rightresponse.ai/SignalRHub/";
    if (appMode === 'prod') return "https://playground.rightresponse.ai/SignalRHub/";

    return "https://localhost:7224/SignalRHub/";
};
const getApiUrl = () => {
    var _apiUrl = 'https://localhost:7224/';
    //var _apiUrl = 'https://devplayground.rightresponse.ai/';
    var _isProdution = window.location.hostname === 'localhost' ? false : true;
    if (_isProdution) {
        _apiUrl = `https://${window.location.hostname}/`;
    }
    return _apiUrl;
};

const getIntSvcApiUrl = () => {
    var _apiUrl = 'http://localhost:54321/';
    var _apiUrl = 'https://devintsvc.rightresponse.ai/';
    var _isProdution = window.location.hostname === 'localhost' ? false : true;
    if (_isProdution) {
        const appMode = getAppMode();
        // if (_.includes(['dev', 'test'], appMode)) {
            if (appMode === 'dev') return "https://dev.rrops.com/";
            if (appMode === 'test') return "https://test.rrops.com/";
            if (appMode === 'demo') return "https://demo.rrops.com/";
            if (appMode === 'prod') return "https://rr.rrops.com/";
            if (appMode === 'testrmp') return "https://rmptest.rrops.com/";
            if (appMode === 'prodrmp') return "https://rmp.rrops.com/";
        // }
        // else if (_.includes(appMode, 'rmp')) {
        //     _apiUrl = `https://${appMode.replace('rmp', '').replace('prod', '')}intsvc.reviewmgmtportal.com/`
        // }
        // else {
        //     _apiUrl = `https://${appMode.replace('prod', '')}intsvc.rightresponse.ai/`;
        // }

    }
    return _apiUrl;
};
const getRRApiUrl = () => {
    const appMode = getAppMode();
    var _apiUrl = 'https://localhost:7217/';
    var _apiUrl = 'https://devapi.rrops.com/';
    var _isProdution = window.location.hostname === 'localhost' ? false : true;
    if (_isProdution) {
        // if(_.includes(['dev','test'], appMode)) {
           if (appMode === 'dev') return "https://devapi.rrops.com/";
            if (appMode === 'test') return "https://testapi.rrops.com/";
            if (appMode === 'demo') return "https://demoapi.rrops.com/";
            if (appMode === 'prod') return "https://rrapi.rrops.com/";
            if (appMode === 'testrmp') return "https://rmptestapi.rrops.com/";
            if (appMode === 'prodrmp') return "https://rmpapi.rrops.com/";
        // }
        _apiUrl = _.includes(appMode, 'rmp') ? `https://${appMode === 'prodrmp' ? 'app' : appMode}.reviewmgmtportal.com/` : `https://${appMode === 'prod' ? 'app' : appMode}.rightresponse.ai/`;
    }
    return _apiUrl;
};

const AppConfig = {
    appMode: getAppMode(), // local or dev or prod
    signalRAutoRefreshUrl: getSignalRAutoRefreshUrl(),
    liveSessionId: getLiveSessionId(),
    env: function (config) {
        if (this.appMode === 'prod') {
            return this.prod[config];
        }
        else if (this.appMode === 'dev') {
            return this.dev[config];
        }
        else {
            return this.local[config];
        }
    },
    envs: getEnvs(),
    envsList: getEnvsList(),
    allEnvsList: allEnvList,
    baseUrl: getBaseUrl(),
    apiUrl: getApiUrl(),
    intSvcApiUrl: getIntSvcApiUrl(),
    RRApiURL: getRRApiUrl(),
    reduxLogger: () => {
        return (getAppMode() === 'prod' ? false : true);
    },
    axiosLogger: () => {
        return (getAppMode() === 'prod' ? false : true);
    },
    local: {
        connectionId: ''
    },
    dev: {
        connectionId: ''
    },
    test: {
        connectionId: ''
    },
    prod: {
        connectionId: ''
    }
}

export default AppConfig;
